import React from 'react'

import { useClubContext } from '../../contexts/ClubContext'
import { BuyAgainShelf } from '../sections/BuyAgainShelf'
import { TourUserLogged } from '../sections/TourUserLogged'

import type { ProductLayout } from '../../types/Product'

interface BuyAgainProps {
  data?: { isActive: boolean; shelfLayout?: ProductLayout }
}

export const BuyAgain = ({ data }: BuyAgainProps) => {
  const { isClubClient } = useClubContext()

  if (!data?.isActive || !isClubClient) {
    return null
  }

  return (
    <>
      <BuyAgainShelf layout={data?.shelfLayout} />
      <TourUserLogged />
    </>
  )
}
